<template>
    <input
        v-model="confirmation"
        name="confirmation"
        class="form-control"
        autocomplete="off"
        :class="{
            'border-danger': formErrors.includes('confirmation')
        }"
    />
</template>
<script>
export default {
    props: {
        confirmationText: {
            type: String,
            required: true
        }
    },
    computed: {
        isConfirmationTextMatch() {
            return this.confirmation === this.confirmationText;
        }
    },
    data() {
        return {
            confirmation: "",
            formErrors: []
        };
    },
    watch: {
        confirmation(value) {
            this.removeErrors("confirmation");
            this.$emit("is-matched", this.isConfirmationTextMatch);
        }
    },
    methods: {
        isValid() {
            const isConfirmationValid =
                this.confirmation === this.confirmationText;

            if (!isConfirmationValid) {
                this.formErrors.push("confirmation");
            }
            return isConfirmationValid;
        },
        removeErrors(key) {
            this.formErrors = this.formErrors.filter(err => err !== key);
        }
    }
};
</script>
